'use client';

import { useEffect } from 'react';
import { initializeAnalytics } from '@/features/tracking/lib/init';

export function Analytics() {
  useEffect(() => {
    initializeAnalytics();
  }, []);

  return null;
}
